import {get} from 'lodash';
export function state(initialState) {
  return {
    listings: {},
    listingDetails: get(initialState, 'listingDetails') || {},
  };
}

